(function webpackUniversalModuleDefinition(root, factory) {
	if(typeof exports === 'object' && typeof module === 'object')
		module.exports = factory(require("mggp-player"));
	else if(typeof define === 'function' && define.amd)
		define(["mggp-player"], factory);
	else if(typeof exports === 'object')
		exports["mggp-plugin-vod-channels-cms"] = factory(require("mggp-player"));
	else
		root["mggp-plugin-vod-channels-cms"] = factory(root["mggp-player"]);
})(self, (__WEBPACK_EXTERNAL_MODULE_mggp_player__) => {
return 